import { createSelector } from 'reselect';
import { ISlideshow } from '../types/slideshow';

export const getSlideshowsList = (state: { slideshowsList: ISlideshow[] }) => state.slideshowsList;
export const getSlideshowsById = createSelector(
  getSlideshowsList,
  (slideshowsList: ISlideshow[]) => (albumId: string) =>
    slideshowsList.filter((slideshow) => slideshow.albumId === albumId)
);
